module.exports = __webpack_public_path__ + "img/wedding-dress_2.b002c7f4.png";